/**
 * FreemiumUpgradeBanner Component
 * Displays upgrade prompt for free users who have used their one free domain analysis
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, Star, Trophy, Zap } from 'lucide-react';

export function FreemiumUpgradeBanner({ totalActions, shownActions, onUpgrade }) {
  const navigate = useNavigate();

  const handleUpgradeClick = () => {
    if (onUpgrade) {
      onUpgrade();
    } else {
      navigate('/account/upgrade');
    }
  };

  const features = [
    {
      icon: <Trophy className="w-5 h-5 text-yellow-500" />,
      text: `All ${totalActions} actionable recommendations`
    },
    {
      icon: <Zap className="w-5 h-5 text-blue-500" />,
      text: "Credits to analyze more domains"
    },
    {
      icon: <Star className="w-5 h-5 text-purple-500" />,
      text: "Priority support & updates"
    }
  ];

  return (
    <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 rounded-lg p-6 mb-6">
      <div className="text-center">
        {/* Header */}
        <div className="mb-4">
          <h3 className="text-xl font-bold text-foreground mb-2">
            🎉 Your SEO audit found 100+wins
          </h3>
          <p className="text-muted-foreground text-base mb-2">
            <strong>Analysis complete</strong>. Preview {shownActions} quick
            fixes below, then unlock the full playbook.
          </p>
          <div className="text-sm text-card-foreground font-medium">
            {shownActions} Preview Fixes → All {totalActions} Actions →
            Unlimited Sites
          </div>
          <p className="text-sm text-muted-foreground mt-2">
            Get every recommendation that'll boost your rankings, plus analyze
            any domain you want.
          </p>
        </div>

        {/* CTA Buttons */}
        <div className="space-y-3 mt-8">
          <button
            onClick={handleUpgradeClick}
            className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 transition-colors"
          >
            Unlock the full list
            <ArrowRight className="ml-2 h-5 w-5" />
          </button>

          <p className="text-xs text-muted-foreground">
            Join thousands of sites already climbing search results.
          </p>
        </div>
      </div>
    </div>
  );
}

export default FreemiumUpgradeBanner;
